import type { Location, NavigateFunction } from 'react-router-dom'
import type { Crumb } from '@/components/breadcrumb/Breadcrumb'

/**
 * Builds the new-member page breadcrumb trail in the shape the shared `Breadcrumb`
 * component consumes (`Crumb[]`).
 *
 * Each legacy `{ site, location }` entry maps to `{ label, onClick }`: a non-empty
 * `location` becomes an `onClick` that navigates there (rendered as a `<button>`); the
 * final "New member" crumb has an empty location and therefore no `onClick`, so the
 * shared component renders it as the current-page `<span>`.
 */
export const getBreadCrumbs = (location: Location, navigate: NavigateFunction): Crumb[] => {
  const pageCrumbs = [
    {
      site: 'Management',
      location: `/management${location.search || ''}`,
    },
    {
      site: 'New member',
      location: '',
    },
  ]

  return pageCrumbs.map((crumb) =>
    crumb.location ? { label: crumb.site, onClick: () => navigate(crumb.location) } : { label: crumb.site },
  )
}
